module.exports = __webpack_public_path__ + "img/kitimg7.f52f0c91.jpg";